<!--
  @负责人: libaiqi
  @创建时间: 2019-01-02
  @版本:v2.0.0
  @描述: 站点导航
-->
<template>
  <div class="siteNavigation__content">
    <div class="siteNavigation__form">
      <el-form ref="form" :model="form" :inline="true" input-width="auto">
        <el-form-item :label="$t('siteNavigation.name')">
          <el-input v-model="form.name" ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="e_search" v-g-rac="gRac('navigationSetting@search')">{{ $t('common.search') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="siteNavigation__site" v-show="siteData.length > 0">
      <div v-for="(item,index) in siteData" :key="index" class="navigationSetting__site--single" v-g-rac="gRac('navigationSetting@jump')" @click="e_jump(item)">
        <span class="navigationSetting__site--web" v-text="item.name" :title="item.name"></span>
        <div class="navigationSetting__site--name" v-text="item.name"></div>
      </div>
    </div>
    <div class="siteNavigation__noData" v-show="siteData.length === 0">
      {{$t('siteNavigation.noDAta')}}
    </div>
  </div>
</template>
<script>
  import rac from '@/plugins/rac-mixin'
  import navigationSettingBiz from '@/logic/intelligentMonitor/navigationSettingBiz'

  export default {
    mixins: [rac],
    data () {
      return {
        form: {
          name: ''
        },
        siteData: []
      }
    },
    methods: {
      e_search () {
        navigationSettingBiz.getSite(this.form).then((data) => {
          this.siteData = data
        })
      },
      e_jump (data) {
        window.open(data.location)
      }
    },
    mounted () {
      this.e_search()
    },
    watch: {
      '$route' (nV, oV) {
        if (nV.name === 'siteNavigation' && oV.name === 'navigationSetting') {
          this.e_search()
        }
      }
    }
  }
</script>
<style scoped>
  .siteNavigation__site {
    width: 100%;
    margin-top: 10px
  }
  .navigationSetting__site--single {
    width: 200px;
    height: 80px;
    line-height: 75px;
    text-align: center;
    display: inline-block;
    position: relative;
    cursor: pointer;
    border: 1px solid #9dd1f5;
    font-size: 20px;
    margin-right: 20px;
    margin-bottom: 40px;
    background: #e7f4fc;
    color: #0B8DE5;
    border-radius: 4px;
  }
  .navigationSetting__site--single:hover {
    background: #0B8DE5;
    border-color: #0B8DE5;
    color: #fff;
  }
  .navigationSetting__site--single:hover .navigationSetting__site--name{
    color: #0B8DE5;
  }
  .navigationSetting__site--single .navigationSetting__site--web {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .navigationSetting__site--single .navigationSetting__site--name {
    line-height: 0;
    font-size: 16px;
  }
  .siteNavigation__noData {
    text-align:  center;
    font-size: 16px;
    font-weight: 600;
    margin-top: 10px;
  }
</style>